import * as React from 'react';
export const IcBeautyProducts = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9 4a1 1 0 00-.17-.56 1 1 0 00-.45-.36A1 1 0 007.8 3a1 1 0 00-.51.27l-2 2a1 1 0 00-.22.32c-.05.13-.074.27-.07.41v4h4V4zM4 19a2 2 0 002 2h2a2 2 0 002-2v-7H4v7zm10 0a2 2 0 004 0v-7h-4v7zm6.89-13.44a5.33 5.33 0 00-2.09-2A5.91 5.91 0 0016 3a6 6 0 00-2.81.6 5.35 5.35 0 00-2.1 2 1.1 1.1 0 00-.09.51c.02.175.082.343.18.49l2.56 3.4h4.51l2.55-3.39a1.07 1.07 0 00.2-.52 1 1 0 00-.11-.53z'
      fill='currentColor'
    />
  </svg>
);
